import { useEffect, useState } from 'react'

export function useAppVersionCheck(interval: number = 30000) {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    let currentVersion: string | null = null

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' })
        if (!res.ok) return

        const data: { version: string } = await res.json()
        if (!currentVersion) {
          currentVersion = data.version
        } else if (currentVersion !== data.version) {
          setUpdateAvailable(true)
        }
      } catch (err) {
        console.warn('Version check failed:', err)
      }
    }

    const id = setInterval(checkVersion, interval)
    checkVersion()

    return () => clearInterval(id)
  }, [interval])

  const reload = () => {
    window.location.reload()
  }

  return { updateAvailable, reload }
}
